<template>
  <div class="contents" v-if="opened">
    <search-venues
        v-if="enableSearching"
        :venues="venues"
        placeholder="Search venues..."
        v-on:search="showSearchResults = $event"
        v-on:results="searchResults = $event">
    </search-venues>

    <div class="scroll-height">
        <template v-if="loading">
            <list-slot
                    v-for="n in venueIds.length"
                    :key="'venuePlaceholder' + n"
                    placeholder="true">
            </list-slot>
        </template>

        <template v-if="!showSearchResults">
            <div>
                <list-slot
                        v-for="venue in venues"
                        :key="venue.id"
                        :main-text="venue.name"
                        :sub-text="venue.address"
                        :disabled="false"
                        :selected="false"
                        v-on:click="selectVenue(venue)">
                </list-slot>
            </div>
        </template>

        <template v-if="showSearchResults">
            <div>
                <list-slot
                        v-for="venue in searchResults"
                        :key="venue.id + 'search'"
                        :main-text="venue.name"
                        :sub-text="venue.address"
                        :disabled="false"
                        :selected="false"
                        v-on:click="selectVenue(venue)">
                </list-slot>
            </div>
        </template>

    </div>
  </div>
</template>

<script>
  import VenueProvider from '../services/VenueProvider'
  import searchVenues from './searchVenues'
  import listSlot from './listSlot'

  export default {
    name: 'venueStage',
    props: [
      'venueIds',
      'enableSearching',
      'opened',
      'value'
    ],
    components: {
      searchVenues,
      listSlot
    },
    data () {
      return {
        loading: true,
        venues: [],
        searchResults: [],
        showSearchResults: false
      }
    },
    mounted () {
      this.venueProvider = new VenueProvider()

      this.venueProvider.setUrlOptions({
        source: this.$root.dmnOptions.from
      })
    },
    methods: {
      selectVenue (venue) {
        this.showSearchResults = false
        this.searchResults = []
        this.$emit('input', venue)
      },
      async requestVenues (chunkSize = 5, limit = 999) {
        this.loading = true
        this.venues = []
        this.$root._venues = []
        const useCache = true

        this.venueProvider.removeAllExpiredItems()

        // HACK: Required to move to next tick (single venues seem to load v. quickly from the cache and the dom isn't ready)
        await setTimeout(() => {}, 0)

        for (let i = 0; i < this.venueIds.length && i < limit; i += chunkSize) {
          let chunkedIds = this.venueIds.slice(i, i + chunkSize)
          let chunkHash = this.venueProvider.getVenueHash(chunkedIds)
          let cachedVenues = useCache ? this.venueProvider.requestVenuesFromCache(chunkHash) : false

          let venues = cachedVenues || await this.venueProvider.requestVenues(chunkedIds)

          if (useCache && !cachedVenues) {
            this.venueProvider.cacheVenues(venues)
          }

          this.venues = this.venues.concat(venues)
          this.$root._venues = this.$root._venues.concat(venues)

          this.loading = false
        }

        if (this.venueIds.length === 1) {
          this.selectVenue(this.venues[0])
        }

        return this.venues
      }
    }
  }
</script>



// WEBPACK FOOTER //
// venueStage.vue?c8b8190e